module.exports = __webpack_public_path__ + "static/media/Nepzaimage.8d1820ac.png";